export function normalizeColumnName(name: string, keepParentheses = false): string {
  if (!name) return ''
  let cleaned = name.replace(/[\r\n]+/g, ' ').toLowerCase()
  if (!keepParentheses) {
    cleaned = cleaned.replace(/\s*\([^)]*\)\s*/g, '')
  }
  return cleaned
    .replace(/[áàâãä]/g, 'a')
    .replace(/[éèêë]/g, 'e')
    .replace(/[íìîï]/g, 'i')
    .replace(/[óòôõöº]/g, 'o')
    .replace(/[úùûü]/g, 'u')
    .replace(/[ç]/g, 'c')
    .replace(/[ñ]/g, 'n')
    .replace(/[ª]/g, 'a')
    .replace(/\s+/g, ' ')
    .trim()
}

export function extractPossibleNames(name: string): string[] {
  const withParentheses = normalizeColumnName(name, true)
  const withoutParentheses = normalizeColumnName(name, false)
  const names = [withParentheses]
  if (withoutParentheses !== withParentheses) {
    names.push(withoutParentheses)
  }

  const finalNames = [...names]
  names.forEach(n => {
    if (n.includes(' = ')) {
      const parts = n.split(' = ')
      finalNames.push(parts[0].trim())
      finalNames.push(parts[1].trim())
    }
    if (n.includes(' - ')) {
      const parts = n.split(' - ')
      finalNames.push(parts[0].trim())
      finalNames.push(parts[1].trim())
    }
  })

  return finalNames
}

export const columnMappingRules: { [key: string]: string } = {
  acabamento: 'finishing',
  fabricacao: 'fabrication',
  'cmc total': 'totalCmc',
  comprimento: 'lengthInMm',
  'custo por kg': 'costPerKg',
  'custo (kg)': 'costPerKg',
  'custo por mm': 'costPerMm',
  'custo (mm)': 'costPerMm',
  'custo (un)': 'price',
  'custo total': 'totalCost',
  codigo: 'code',
  'data de recebimento': 'receivedDate',
  densidade: 'density',
  'dimensao 1': 'dimension1',
  'dimensao 2': 'dimension2',
  formato: 'format',
  fornecedor: 'supplier',
  material: 'material',
  ncm: 'ncm',
  'n de corrida': 'heatNumber',
  'no de corrida': 'heatNumber',
  'numero de corrida': 'heatNumber',
  'n de rastreamento': 'trackingNumber',
  'no de rastreamento': 'trackingNumber',
  'numero de rastreamento': 'trackingNumber',
  rastreamento: 'trackingNumber',
  re: 'trackingNumber',
  descricao: 'description',
  caracteristica: 'characteristic',
  familia: 'family',
  'ordem de compra': 'purchaseOrder',
  'pais de origem': 'originCountry',
  'peso total': 'totalWeight',
  peso: 'totalWeight',
  quantidade: 'quantity',
  'quantidade (un)': 'quantity',
  'tratamento termico': 'heatTreatment',
  unidade: 'measurementUnit',
  rua: 'stockStreet',
  prateleira: 'shelf',
  localizacao: 'stockLocation',
  cor: 'color',
}

export function autoMapSpreadsheetHeaders(headers: string[]): { [key: string]: string } {
  console.log('[AUTO-MAP] Iniciando mapeamento automático dos cabeçalhos:', headers);
  const mapping: { [key: string]: string } = {}
  
  headers.forEach((header) => {
    const possibleNames = extractPossibleNames(header)
    console.log(`[AUTO-MAP] Header: "${header}" -> nomes possíveis para busca:`, possibleNames);
    let mappedValue: string | undefined
    let matchedName: string | undefined
    
    for (const name of possibleNames) {
      if (columnMappingRules[name]) {
        mappedValue = columnMappingRules[name]
        matchedName = name
        break
      }
    }
    
    if (mappedValue) {
      mapping[header] = mappedValue
      console.log(`[AUTO-MAP] MATCH ENCONTRADO: "${header}" -> "${mappedValue}" (matched rule name: "${matchedName}")`);
    } else {
      console.log(`[AUTO-MAP] Nenhum match encontrado para: "${header}"`);
    }
  })
  
  console.log('[AUTO-MAP] Mapeamento automático final construído:', mapping);
  return mapping
}
